import './index.css';
import './App.css';

import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import Chatbot        from './components/Chatbot';
import AuthGuard      from './components/AuthGuard';
import AdminAuthGuard from './components/AdminAuthGuard';
import AdminDashboard from './pages/AdminDashboard';
import { ClientConfigProvider } from './context/ClientConfigContext';

const hostname = window.location.hostname;
const isSubdomain = hostname.includes('navigateiq.ai');
const isAdminSubdomain = hostname.startsWith('admin');
const isAdminMode = process.env.REACT_APP_MODE === 'admin';

// ── Client app — slug from hostname (subdomain) or URL path (IP/localhost) ──
function ClientApp() {
  const { slug: pathSlug } = useParams();
  const slug = isSubdomain ? hostname.split('.')[0] : pathSlug;
  return (
    <ClientConfigProvider slug={slug}>
      <AuthGuard>
        <Chatbot />
      </AuthGuard>
    </ClientConfigProvider>
  );
}

// ── Admin app ───────────────────────────────────────────────────────────────
function AdminApp() {
  return (
    <AdminAuthGuard>
      <AdminDashboard />
    </AdminAuthGuard>
  );
}

// ── Root placeholder ────────────────────────────────────────────────────────
function Placeholder() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f1419',
      color: 'rgba(255,255,255,0.3)',
      fontFamily: 'sans-serif',
      fontSize: 14,
    }}>
      Navigate IQ
    </div>
  );
}

// ── Root app with routing ───────────────────────────────────────────────────
function App() {
  // Subdomain mode — route everything based on hostname
  if (isSubdomain) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={isAdminSubdomain ? <AdminApp /> : <ClientApp />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // Path mode — original routing for IP/localhost access (no domain)
  // Admin mode: only serve /admin route
  if (isAdminMode) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:slug"   element={<ClientApp />} />
        <Route path="/"        element={<Placeholder />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
